import { render, staticRenderFns } from "./blok-grid.vue?vue&type=template&id=565480ee&scoped=true&"
import script from "./blok-grid.vue?vue&type=script&lang=js&"
export * from "./blok-grid.vue?vue&type=script&lang=js&"
import style0 from "./blok-grid.vue?vue&type=style&index=0&id=565480ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565480ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('565480ee')) {
      api.createRecord('565480ee', component.options)
    } else {
      api.reload('565480ee', component.options)
    }
    module.hot.accept("./blok-grid.vue?vue&type=template&id=565480ee&scoped=true&", function () {
      api.rerender('565480ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/blok-grid.vue"
export default component.exports